// extracted by mini-css-extract-plugin
export default {"downloadIcon":"flightreport_downloadIcon__Xhggx","downloadWrapper":"flightreport_downloadWrapper__9TOk-","downloadBtnWrapper":"flightreport_downloadBtnWrapper__F0bWT"};